module.exports = "<div class=\"wrapper \">\n   <app-loader></app-loader>\n    <router-outlet></router-outlet>\n   \n    \n\n</div>"